import React from "react"

export const TwitterXIconSolid = ({ size = 1, color = "#034055" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 50"
      width={size * 28}
      height={size * 28}
    >
      <g>
        <path
          fill={color}
          d="M39,4H11c-3.866,0-7,3.134-7,7v28c0,3.866,3.134,7,7,7h28c3.866,0,7-3.134,7-7V11C46,7.134,42.866,4,39,4z M29.978,37
		l-6.54-9.292L15.5,37H13l9.308-10.897L13.086,13h7.937l5.637,8.009L33.5,13H36l-8.211,9.613L37.914,37H29.978z"
        />
        <polygon
          fill={color}
          points="16.914,15 31.022,35 34.086,35 19.978,15 	"
        />
      </g>
    </svg>
  )
}
